var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUgx = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9434 20.2697C22.8439 18.1466 24 15.3434 24 12.2697C24 9.19601 22.8438 6.39274 20.9434 4.26968L12 3.40015L3.05662 4.26968C1.15617 6.39274 0 9.19601 0 12.2697C0 15.3434 1.15613 18.1466 3.05658 20.2697L12 21.1392L20.9434 20.2697Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05664 4.26732H20.9434C18.7462 1.81262 15.5537 0.267334 12 0.267334C8.44628 0.267334 5.25386 1.81262 3.05664 4.26732Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2674L12 13.3108L24 12.2674C24 10.8647 23.7585 9.51852 23.3162 8.26733H0.683812C0.241453 9.51852 0 10.8647 0 12.2674Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.683812 16.2673H23.3163C23.7585 15.0161 24 13.67 24 12.2673H0C0 13.67 0.241453 15.0161 0.683812 16.2673Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9435 20.2673H3.05664C5.25386 22.7221 8.44628 24.2674 12.0001 24.2674C15.5538 24.2674 18.7463 22.7221 20.9435 20.2673Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0048 12.2678C16.0048 14.4795 14.2121 16.2721 12.0004 16.2721C9.78874 16.2721 7.99609 14.4795 7.99609 12.2678C7.99609 10.0561 9.78874 8.26343 12.0004 8.26343C14.2121 8.26343 16.0048 10.0561 16.0048 12.2678Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4669 12.469L11.9999 11.8334C11.9999 11.8334 12.3431 10.6941 12.3614 10.6162C12.3748 10.5592 12.3819 10.4999 12.3819 10.4388C12.3819 10.2227 12.2943 10.027 12.1526 9.88546L12.5215 9.51655C12.2855 9.28054 11.9594 9.13452 11.5992 9.13452C11.239 9.13452 10.9129 9.28049 10.6769 9.51655L11.0458 9.88546C10.9042 10.0271 10.8166 10.2227 10.8166 10.4388C10.8166 10.5179 10.8285 10.594 10.8503 10.666L10.2949 11.2214H11.3044C11.3044 11.2214 10.887 11.8483 10.6592 12.3631C10.4313 12.8779 10.6623 13.5063 11.1889 13.7404L11.4934 13.8757L11.9999 14.3518V14.8735L11.4782 15.3952H12.5217V14.3518L12.9978 13.8757H13.9825C13.9873 13.8659 13.9922 13.8563 13.9967 13.8463C14.2307 13.3197 13.9935 12.703 13.4669 12.469Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUgx);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/UGX.a598a4bd39f37bd056b6e33115674dfc.svg";